import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "echipa-wrap" }
const _hoisted_2 = { class: "filter-row" }
const _hoisted_3 = { class: "filter-group" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-center py-8"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "summary-inner" }
const _hoisted_7 = {
  class: "summary-icon",
  style: {"background":"rgba(255,87,34,0.1)"}
}
const _hoisted_8 = { class: "summary-value" }
const _hoisted_9 = { class: "summary-inner" }
const _hoisted_10 = {
  class: "summary-icon",
  style: {"background":"rgba(76,175,80,0.1)"}
}
const _hoisted_11 = { class: "summary-value" }
const _hoisted_12 = { class: "summary-inner" }
const _hoisted_13 = { class: "matrix-title" }
const _hoisted_14 = { class: "table-scroll" }
const _hoisted_15 = { class: "matrix-table" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "agent-col" }
const _hoisted_18 = { class: "agent-name-wrap" }
const _hoisted_19 = { class: "agent-name" }
const _hoisted_20 = { class: "cell-target" }
const _hoisted_21 = { class: "cell-bar-wrap" }
const _hoisted_22 = { class: "cell-bar" }
const _hoisted_23 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_24 = { class: "medie-col" }
const _hoisted_25 = {
  key: 0,
  class: "detalii-row"
}
const _hoisted_26 = ["colspan"]
const _hoisted_27 = { class: "detalii-content" }
const _hoisted_28 = {
  key: 0,
  class: "d-flex justify-center py-4"
}
const _hoisted_29 = {
  key: 1,
  class: "kpi-detalii-grid"
}
const _hoisted_30 = { class: "kpi-block-header" }
const _hoisted_31 = { class: "kpi-block-title" }
const _hoisted_32 = { class: "kpi-block-progress-row" }
const _hoisted_33 = { class: "kpi-block-bar" }
const _hoisted_34 = { class: "kpi-block-body" }
const _hoisted_35 = {
  key: 0,
  class: "kpi-block-empty"
}
const _hoisted_36 = {
  key: 1,
  class: "mini-scroll"
}
const _hoisted_37 = { class: "mini-table" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { key: 3 }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "mini-col-main" }
const _hoisted_44 = {
  key: 0,
  class: "mini-col-client"
}
const _hoisted_45 = {
  key: 1,
  class: "mini-col-info"
}
const _hoisted_46 = {
  key: 2,
  class: "mini-col-val"
}
const _hoisted_47 = { key: 3 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "mini-col-data" }
const _hoisted_50 = {
  key: 1,
  class: "kpi-block-empty"
}
const _hoisted_51 = { class: "matrix-title" }
const _hoisted_52 = { class: "table-scroll" }
const _hoisted_53 = { class: "matrix-table" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "agent-col" }
const _hoisted_56 = { class: "agent-name-wrap" }
const _hoisted_57 = { class: "agent-name" }
const _hoisted_58 = { class: "cell-target" }
const _hoisted_59 = { class: "cell-bar-wrap" }
const _hoisted_60 = { class: "cell-bar" }
const _hoisted_61 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_62 = { class: "medie-col" }
const _hoisted_63 = {
  key: 0,
  class: "detalii-row"
}
const _hoisted_64 = ["colspan"]
const _hoisted_65 = { class: "detalii-content" }
const _hoisted_66 = {
  key: 0,
  class: "d-flex justify-center py-4"
}
const _hoisted_67 = {
  key: 1,
  class: "kpi-detalii-grid"
}
const _hoisted_68 = { class: "kpi-block-header" }
const _hoisted_69 = { class: "kpi-block-title" }
const _hoisted_70 = { class: "kpi-block-progress-row" }
const _hoisted_71 = { class: "kpi-block-bar" }
const _hoisted_72 = { class: "kpi-block-body" }
const _hoisted_73 = {
  key: 0,
  class: "kpi-block-empty"
}
const _hoisted_74 = {
  key: 1,
  class: "mini-scroll"
}
const _hoisted_75 = { class: "mini-table" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { key: 2 }
const _hoisted_79 = { key: 3 }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "mini-col-main" }
const _hoisted_82 = {
  key: 0,
  class: "mini-col-client"
}
const _hoisted_83 = {
  key: 1,
  class: "mini-col-info"
}
const _hoisted_84 = {
  key: 2,
  class: "mini-col-val"
}
const _hoisted_85 = { key: 3 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { class: "mini-col-data" }
const _hoisted_88 = {
  key: 1,
  class: "kpi-block-empty"
}
const _hoisted_89 = {
  key: 3,
  class: "text-center text-grey py-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      elevation: "1",
      class: "filter-card mb-4"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1",
              color: "grey"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-calendar-month", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_select, {
              modelValue: _ctx.luna,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.luna) = $event)),
              items: _ctx.luni,
              "item-title": "label",
              "item-value": "value",
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              class: "filter-select"
            }, null, 8, ["modelValue", "items"]),
            _createVNode(_component_v_select, {
              modelValue: _ctx.an,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.an) = $event)),
              items: _ctx.ani,
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              class: "filter-select ml-2"
            }, null, 8, ["modelValue", "items"])
          ]),
          _createVNode(_component_v_btn, {
            color: _ctx.APP_Color,
            size: "small",
            class: "refresh-btn",
            loading: _ctx.loading,
            onClick: _ctx.incarca
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                size: "16",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-refresh", -1)
                ]))]),
                _: 1
              }),
              _cache[4] || (_cache[4] = _createTextVNode(" Încarcă ", -1))
            ]),
            _: 1
          }, 8, ["color", "loading", "onClick"])
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: _ctx.APP_Color,
            size: "40"
          }, null, 8, ["color"])
        ]))
      : (!_ctx.loading && _ctx.echipaData.length === 0 && _ctx.loaded)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            type: "info",
            variant: "tonal"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" Nu există agenți cu rol activ în această perioadă. ", -1)
            ]))]),
            _: 1
          }))
        : (!_ctx.loading && _ctx.echipaData.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_v_row, {
                class: "mb-4",
                dense: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "summary-card",
                        elevation: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_v_icon, {
                                color: "deep-orange",
                                size: "22"
                              }, {
                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                  _createTextVNode("mdi-account-search", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.hunterAgenti.length), 1),
                              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "summary-label" }, "Agenți Hunter", -1))
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "summary-card",
                        elevation: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_v_icon, {
                                color: "green",
                                size: "22"
                              }, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                  _createTextVNode("mdi-account-tie", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.farmerAgenti.length), 1),
                              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "summary-label" }, "Agenți Farmer", -1))
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "summary-card",
                        elevation: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", {
                              class: "summary-icon",
                              style: _normalizeStyle({ background: `rgba(${_ctx.medieEchipaRGB},0.1)` })
                            }, [
                              _createVNode(_component_v_icon, {
                                color: _ctx.medieEchipaColor,
                                size: "22"
                              }, {
                                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                  _createTextVNode("mdi-chart-donut", -1)
                                ]))]),
                                _: 1
                              }, 8, ["color"])
                            ], 4),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", {
                                class: "summary-value",
                                style: _normalizeStyle({ color: _ctx.medieEchipaColor })
                              }, _toDisplayString(_ctx.medieEchipa) + "%", 5),
                              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "summary-label" }, "Medie echipă", -1))
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.hunterAgenti.length > 0)
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 0,
                    elevation: "2",
                    class: "matrix-card mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_v_icon, {
                          color: "deep-orange",
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode("mdi-account-search", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[13] || (_cache[13] = _createTextVNode(" Hunter — Achiziție clienți noi ", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "matrix-hint ml-2" }, "click pe agent pentru detalii", -1))
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("table", _hoisted_15, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _cache[15] || (_cache[15] = _createElementVNode("th", { class: "agent-col" }, "Agent", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hunterColumns, (col) => {
                                return (_openBlock(), _createElementBlock("th", {
                                  key: col.ID,
                                  class: "kpi-col"
                                }, [
                                  _createVNode(_component_v_tooltip, {
                                    text: col.Denumire,
                                    location: "top"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("span", _mergeProps({ ref_for: true }, props), _toDisplayString(_ctx.abrev(col.Cod)), 17)
                                    ]),
                                    _: 2
                                  }, 1032, ["text"])
                                ]))
                              }), 128)),
                              _cache[16] || (_cache[16] = _createElementVNode("th", { class: "medie-col" }, "Medie %", -1))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hunterAgenti, (member) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: member.Utilizator
                              }, [
                                _createElementVNode("tr", {
                                  class: _normalizeClass(["agent-row", { 'agent-row--expanded': _ctx.expandedAgent === member.Utilizator }]),
                                  onClick: ($event: any) => (_ctx.toggleAgent(member))
                                }, [
                                  _createElementVNode("td", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_v_icon, {
                                        size: "14",
                                        class: _normalizeClass(["expand-chevron mr-1", { 'expand-chevron--open': _ctx.expandedAgent === member.Utilizator }]),
                                        color: "grey"
                                      }, {
                                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                          _createTextVNode("mdi-chevron-right", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["class"]),
                                      _createElementVNode("span", _hoisted_19, _toDisplayString(member.Utilizator), 1)
                                    ])
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hunterColumns, (col) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      key: col.ID,
                                      class: "kpi-col"
                                    }, [
                                      (_ctx.getKPI(member, col.ID))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("div", {
                                              class: "cell-wrap",
                                              style: _normalizeStyle({ color: _ctx.kpiColor(_ctx.getKPI(member, col.ID).ProcentRealizat) })
                                            }, [
                                              _createElementVNode("strong", null, _toDisplayString(_ctx.getKPI(member, col.ID).Realizat), 1),
                                              _createElementVNode("span", _hoisted_20, "/" + _toDisplayString(_ctx.getKPI(member, col.ID).Target), 1)
                                            ], 4),
                                            _createElementVNode("div", _hoisted_21, [
                                              _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("div", {
                                                  class: "cell-fill",
                                                  style: _normalizeStyle({ width: Math.min(_ctx.getKPI(member, col.ID).ProcentRealizat, 100) + '%',
                                      background: _ctx.kpiColor(_ctx.getKPI(member, col.ID).ProcentRealizat) })
                                                }, null, 4)
                                              ]),
                                              _createElementVNode("span", {
                                                class: "cell-pct",
                                                style: _normalizeStyle({ color: _ctx.kpiColor(_ctx.getKPI(member, col.ID).ProcentRealizat) })
                                              }, _toDisplayString(_ctx.getKPI(member, col.ID).ProcentRealizat) + "% ", 5)
                                            ])
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_23, "—"))
                                    ]))
                                  }), 128)),
                                  _createElementVNode("td", _hoisted_24, [
                                    _createVNode(_component_v_chip, {
                                      color: _ctx.kpiChipColor(_ctx.medieMember(member.KPIs)),
                                      size: "small",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.medieMember(member.KPIs)) + "% ", 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"])
                                  ])
                                ], 10, _hoisted_16),
                                (_ctx.expandedAgent === member.Utilizator)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                                      _createElementVNode("td", {
                                        colspan: _ctx.hunterColumns.length + 2,
                                        class: "detalii-cell"
                                      }, [
                                        _createElementVNode("div", _hoisted_27, [
                                          (_ctx.loadingAgentDetalii[member.Utilizator])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                _createVNode(_component_v_progress_circular, {
                                                  indeterminate: "",
                                                  color: _ctx.APP_Color,
                                                  size: "30"
                                                }, null, 8, ["color"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.KPIs, (kpi) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: kpi.KPIDefinitieID,
                                                    class: "kpi-detalii-block"
                                                  }, [
                                                    _createElementVNode("div", _hoisted_30, [
                                                      _createElementVNode("span", _hoisted_31, _toDisplayString(kpi.Denumire), 1),
                                                      _createElementVNode("div", _hoisted_32, [
                                                        _createElementVNode("span", {
                                                          style: _normalizeStyle({ color: _ctx.kpiColor(kpi.ProcentRealizat), fontWeight: '700', fontSize: '0.8rem' })
                                                        }, _toDisplayString(kpi.Realizat) + "/" + _toDisplayString(kpi.Target), 5),
                                                        _createElementVNode("span", {
                                                          class: "kpi-block-pct",
                                                          style: _normalizeStyle({ color: _ctx.kpiColor(kpi.ProcentRealizat) })
                                                        }, _toDisplayString(kpi.ProcentRealizat) + "% ", 5)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_33, [
                                                        _createElementVNode("div", {
                                                          class: "kpi-block-fill",
                                                          style: _normalizeStyle({ width: Math.min(kpi.ProcentRealizat, 100) + '%', background: _ctx.kpiColor(kpi.ProcentRealizat) })
                                                        }, null, 4)
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_34, [
                                                      (_ctx.agentDetalii[member.Utilizator] && _ctx.agentDetalii[member.Utilizator][kpi.KPIDefinitieID] !== undefined)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            (_ctx.agentDetalii[member.Utilizator][kpi.KPIDefinitieID].length === 0)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, " Nicio înregistrare "))
                                                              : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                                  _createElementVNode("table", _hoisted_37, [
                                                                    _createElementVNode("thead", null, [
                                                                      _createElementVNode("tr", null, [
                                                                        _createElementVNode("th", null, _toDisplayString(_ctx.labelColoana(_ctx.getSursaDate(kpi))), 1),
                                                                        (_ctx.areClient(_ctx.getSursaDate(kpi)))
                                                                          ? (_openBlock(), _createElementBlock("th", _hoisted_38, "Client"))
                                                                          : _createCommentVNode("", true),
                                                                        (_ctx.areContact(_ctx.getSursaDate(kpi)))
                                                                          ? (_openBlock(), _createElementBlock("th", _hoisted_39, _toDisplayString(_ctx.labelContact(_ctx.getSursaDate(kpi))), 1))
                                                                          : _createCommentVNode("", true),
                                                                        (_ctx.areValoare(_ctx.getSursaDate(kpi)))
                                                                          ? (_openBlock(), _createElementBlock("th", _hoisted_40, "Valoare"))
                                                                          : _createCommentVNode("", true),
                                                                        (_ctx.areStatus(_ctx.getSursaDate(kpi)))
                                                                          ? (_openBlock(), _createElementBlock("th", _hoisted_41, "Status"))
                                                                          : _createCommentVNode("", true),
                                                                        _cache[18] || (_cache[18] = _createElementVNode("th", null, "Data", -1))
                                                                      ])
                                                                    ]),
                                                                    _createElementVNode("tbody", null, [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agentDetalii[member.Utilizator][kpi.KPIDefinitieID], (row) => {
                                                                        return (_openBlock(), _createElementBlock("tr", {
                                                                          key: row.ID,
                                                                          class: "mini-row-link",
                                                                          onClick: ($event: any) => (_ctx.navigheazaLaDetaliu(_ctx.getSursaDate(kpi), row.ID))
                                                                        }, [
                                                                          _createElementVNode("td", _hoisted_43, _toDisplayString(row.Denumire), 1),
                                                                          (_ctx.areClient(_ctx.getSursaDate(kpi)))
                                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_44, _toDisplayString(row.Client || '—'), 1))
                                                                            : _createCommentVNode("", true),
                                                                          (_ctx.areContact(_ctx.getSursaDate(kpi)))
                                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(row.Contact || '—'), 1))
                                                                            : _createCommentVNode("", true),
                                                                          (_ctx.areValoare(_ctx.getSursaDate(kpi)))
                                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_46, _toDisplayString(row.Valoare != null ? _ctx.formatValoare(row.Valoare) : '—'), 1))
                                                                            : _createCommentVNode("", true),
                                                                          (_ctx.areStatus(_ctx.getSursaDate(kpi)))
                                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_47, [
                                                                                (row.Status)
                                                                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                                      key: 0,
                                                                                      size: "x-small",
                                                                                      variant: "tonal",
                                                                                      color: "blue"
                                                                                    }, {
                                                                                      default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(row.Status), 1)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024))
                                                                                  : (_openBlock(), _createElementBlock("span", _hoisted_48, "—"))
                                                                              ]))
                                                                            : _createCommentVNode("", true),
                                                                          _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.formatData(row.Data)), 1)
                                                                        ], 8, _hoisted_42))
                                                                      }), 128))
                                                                    ])
                                                                  ])
                                                                ]))
                                                          ], 64))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                            _createVNode(_component_v_progress_circular, {
                                                              indeterminate: "",
                                                              size: "14",
                                                              width: "2",
                                                              color: "grey"
                                                            })
                                                          ]))
                                                    ])
                                                  ]))
                                                }), 128))
                                              ]))
                                        ])
                                      ], 8, _hoisted_26)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.farmerAgenti.length > 0)
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 1,
                    elevation: "2",
                    class: "matrix-card"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_v_icon, {
                          color: "green",
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createTextVNode("mdi-account-tie", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[20] || (_cache[20] = _createTextVNode(" Farmer — Gestionare portofoliu ", -1)),
                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "matrix-hint ml-2" }, "click pe agent pentru detalii", -1))
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("table", _hoisted_53, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _cache[22] || (_cache[22] = _createElementVNode("th", { class: "agent-col" }, "Agent", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmerColumns, (col) => {
                                return (_openBlock(), _createElementBlock("th", {
                                  key: col.ID,
                                  class: "kpi-col"
                                }, [
                                  _createVNode(_component_v_tooltip, {
                                    text: col.Denumire,
                                    location: "top"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("span", _mergeProps({ ref_for: true }, props), _toDisplayString(_ctx.abrev(col.Cod)), 17)
                                    ]),
                                    _: 2
                                  }, 1032, ["text"])
                                ]))
                              }), 128)),
                              _cache[23] || (_cache[23] = _createElementVNode("th", { class: "medie-col" }, "Medie %", -1))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmerAgenti, (member) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: member.Utilizator
                              }, [
                                _createElementVNode("tr", {
                                  class: _normalizeClass(["agent-row", { 'agent-row--expanded': _ctx.expandedAgent === member.Utilizator }]),
                                  onClick: ($event: any) => (_ctx.toggleAgent(member))
                                }, [
                                  _createElementVNode("td", _hoisted_55, [
                                    _createElementVNode("div", _hoisted_56, [
                                      _createVNode(_component_v_icon, {
                                        size: "14",
                                        class: _normalizeClass(["expand-chevron mr-1", { 'expand-chevron--open': _ctx.expandedAgent === member.Utilizator }]),
                                        color: "grey"
                                      }, {
                                        default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                          _createTextVNode("mdi-chevron-right", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["class"]),
                                      _createElementVNode("span", _hoisted_57, _toDisplayString(member.Utilizator), 1)
                                    ])
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmerColumns, (col) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      key: col.ID,
                                      class: "kpi-col"
                                    }, [
                                      (_ctx.getKPI(member, col.ID))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("div", {
                                              class: "cell-wrap",
                                              style: _normalizeStyle({ color: _ctx.kpiColor(_ctx.getKPI(member, col.ID).ProcentRealizat) })
                                            }, [
                                              _createElementVNode("strong", null, _toDisplayString(_ctx.getKPI(member, col.ID).Realizat), 1),
                                              _createElementVNode("span", _hoisted_58, "/" + _toDisplayString(_ctx.getKPI(member, col.ID).Target), 1)
                                            ], 4),
                                            _createElementVNode("div", _hoisted_59, [
                                              _createElementVNode("div", _hoisted_60, [
                                                _createElementVNode("div", {
                                                  class: "cell-fill",
                                                  style: _normalizeStyle({ width: Math.min(_ctx.getKPI(member, col.ID).ProcentRealizat, 100) + '%',
                                      background: _ctx.kpiColor(_ctx.getKPI(member, col.ID).ProcentRealizat) })
                                                }, null, 4)
                                              ]),
                                              _createElementVNode("span", {
                                                class: "cell-pct",
                                                style: _normalizeStyle({ color: _ctx.kpiColor(_ctx.getKPI(member, col.ID).ProcentRealizat) })
                                              }, _toDisplayString(_ctx.getKPI(member, col.ID).ProcentRealizat) + "% ", 5)
                                            ])
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_61, "—"))
                                    ]))
                                  }), 128)),
                                  _createElementVNode("td", _hoisted_62, [
                                    _createVNode(_component_v_chip, {
                                      color: _ctx.kpiChipColor(_ctx.medieMember(member.KPIs)),
                                      size: "small",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.medieMember(member.KPIs)) + "% ", 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"])
                                  ])
                                ], 10, _hoisted_54),
                                (_ctx.expandedAgent === member.Utilizator)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_63, [
                                      _createElementVNode("td", {
                                        colspan: _ctx.farmerColumns.length + 2,
                                        class: "detalii-cell"
                                      }, [
                                        _createElementVNode("div", _hoisted_65, [
                                          (_ctx.loadingAgentDetalii[member.Utilizator])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                                _createVNode(_component_v_progress_circular, {
                                                  indeterminate: "",
                                                  color: _ctx.APP_Color,
                                                  size: "30"
                                                }, null, 8, ["color"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.KPIs, (kpi) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: kpi.KPIDefinitieID,
                                                    class: "kpi-detalii-block"
                                                  }, [
                                                    _createElementVNode("div", _hoisted_68, [
                                                      _createElementVNode("span", _hoisted_69, _toDisplayString(kpi.Denumire), 1),
                                                      _createElementVNode("div", _hoisted_70, [
                                                        _createElementVNode("span", {
                                                          style: _normalizeStyle({ color: _ctx.kpiColor(kpi.ProcentRealizat), fontWeight: '700', fontSize: '0.8rem' })
                                                        }, _toDisplayString(kpi.Realizat) + "/" + _toDisplayString(kpi.Target), 5),
                                                        _createElementVNode("span", {
                                                          class: "kpi-block-pct",
                                                          style: _normalizeStyle({ color: _ctx.kpiColor(kpi.ProcentRealizat) })
                                                        }, _toDisplayString(kpi.ProcentRealizat) + "% ", 5)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_71, [
                                                        _createElementVNode("div", {
                                                          class: "kpi-block-fill",
                                                          style: _normalizeStyle({ width: Math.min(kpi.ProcentRealizat, 100) + '%', background: _ctx.kpiColor(kpi.ProcentRealizat) })
                                                        }, null, 4)
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_72, [
                                                      (_ctx.agentDetalii[member.Utilizator] && _ctx.agentDetalii[member.Utilizator][kpi.KPIDefinitieID] !== undefined)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            (_ctx.agentDetalii[member.Utilizator][kpi.KPIDefinitieID].length === 0)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_73, " Nicio înregistrare "))
                                                              : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                                                  _createElementVNode("table", _hoisted_75, [
                                                                    _createElementVNode("thead", null, [
                                                                      _createElementVNode("tr", null, [
                                                                        _createElementVNode("th", null, _toDisplayString(_ctx.labelColoana(_ctx.getSursaDate(kpi))), 1),
                                                                        (_ctx.areClient(_ctx.getSursaDate(kpi)))
                                                                          ? (_openBlock(), _createElementBlock("th", _hoisted_76, "Client"))
                                                                          : _createCommentVNode("", true),
                                                                        (_ctx.areContact(_ctx.getSursaDate(kpi)))
                                                                          ? (_openBlock(), _createElementBlock("th", _hoisted_77, _toDisplayString(_ctx.labelContact(_ctx.getSursaDate(kpi))), 1))
                                                                          : _createCommentVNode("", true),
                                                                        (_ctx.areValoare(_ctx.getSursaDate(kpi)))
                                                                          ? (_openBlock(), _createElementBlock("th", _hoisted_78, "Valoare"))
                                                                          : _createCommentVNode("", true),
                                                                        (_ctx.areStatus(_ctx.getSursaDate(kpi)))
                                                                          ? (_openBlock(), _createElementBlock("th", _hoisted_79, "Status"))
                                                                          : _createCommentVNode("", true),
                                                                        _cache[25] || (_cache[25] = _createElementVNode("th", null, "Data", -1))
                                                                      ])
                                                                    ]),
                                                                    _createElementVNode("tbody", null, [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agentDetalii[member.Utilizator][kpi.KPIDefinitieID], (row) => {
                                                                        return (_openBlock(), _createElementBlock("tr", {
                                                                          key: row.ID,
                                                                          class: "mini-row-link",
                                                                          onClick: ($event: any) => (_ctx.navigheazaLaDetaliu(_ctx.getSursaDate(kpi), row.ID))
                                                                        }, [
                                                                          _createElementVNode("td", _hoisted_81, _toDisplayString(row.Denumire), 1),
                                                                          (_ctx.areClient(_ctx.getSursaDate(kpi)))
                                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_82, _toDisplayString(row.Client || '—'), 1))
                                                                            : _createCommentVNode("", true),
                                                                          (_ctx.areContact(_ctx.getSursaDate(kpi)))
                                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_83, _toDisplayString(row.Contact || '—'), 1))
                                                                            : _createCommentVNode("", true),
                                                                          (_ctx.areValoare(_ctx.getSursaDate(kpi)))
                                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_84, _toDisplayString(row.Valoare != null ? _ctx.formatValoare(row.Valoare) : '—'), 1))
                                                                            : _createCommentVNode("", true),
                                                                          (_ctx.areStatus(_ctx.getSursaDate(kpi)))
                                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_85, [
                                                                                (row.Status)
                                                                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                                      key: 0,
                                                                                      size: "x-small",
                                                                                      variant: "tonal",
                                                                                      color: "blue"
                                                                                    }, {
                                                                                      default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(row.Status), 1)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024))
                                                                                  : (_openBlock(), _createElementBlock("span", _hoisted_86, "—"))
                                                                              ]))
                                                                            : _createCommentVNode("", true),
                                                                          _createElementVNode("td", _hoisted_87, _toDisplayString(_ctx.formatData(row.Data)), 1)
                                                                        ], 8, _hoisted_80))
                                                                      }), 128))
                                                                    ])
                                                                  ])
                                                                ]))
                                                          ], 64))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                                            _createVNode(_component_v_progress_circular, {
                                                              indeterminate: "",
                                                              size: "14",
                                                              width: "2",
                                                              color: "grey"
                                                            })
                                                          ]))
                                                    ])
                                                  ]))
                                                }), 128))
                                              ]))
                                        ])
                                      ], 8, _hoisted_64)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : (!_ctx.loading && !_ctx.loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                _createVNode(_component_v_icon, {
                  size: "40",
                  color: "grey-lighten-2"
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode("mdi-chart-bar", -1)
                  ]))]),
                  _: 1
                }),
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mt-2" }, "Selectați perioada și apăsați „Încarcă\".", -1))
              ]))
            : _createCommentVNode("", true)
  ]))
}